import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ReferralDashboardService } from '@app/features/referralDashboard/services/referral-dashboard.service';
import {
  LoadReferralAccountSettingsRequested,
  LoadReferralAccountSettingsSuccess,
  LoadReferralAccountSettingsFailure,
  UpdateReferralAccountSettingsRequested,
  UpdateReferralAccountSettingsSuccess,
  UpdateReferralAccountSettingsFailure,
} from './referral-account-settings.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ReferralUser } from '@app/core/interfaces/user.interface';
import { SaveResult } from '@app/shared/interfaces/saveResult.interface';
import {ToastService} from '@app/core/services/toast.service';

@Injectable()
export class ReferralAccountSettingsEffects {
  constructor(
    private actions$: Actions,
    private referralAccountSettingsService: ReferralDashboardService,
    private toastService: ToastService
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadReferralAccountSettingsRequested),
      switchMap(() =>
        this.referralAccountSettingsService.getReferralAccountSettings$().pipe(
          map((user: ReferralUser) => LoadReferralAccountSettingsSuccess({ user })),
          catchError((error) => of(LoadReferralAccountSettingsFailure({ error })))
        )
      )
    )
  );

  update$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateReferralAccountSettingsRequested),
      switchMap(({ user }) =>
        this.referralAccountSettingsService.updateReferralAccountSettings$(user).pipe(
          map((result: SaveResult) => {
            if (result?.succeeded) {
              if(result?.successMessages.length > 0) {
                this.toastService.showSuccessToast(result.successMessages.join('<br/>'));
              } else {
                this.toastService.showSuccessToast('Account settings updated successfully.');
              }
              return UpdateReferralAccountSettingsSuccess({ result });
            } else {
              this.toastService.showErrorToast('Something went wrong. Please try again.');
              return UpdateReferralAccountSettingsFailure({
                error: result?.errorMessages?.[0] ?? 'Update failed',
              });
            }
          }),
        )
      )
    )
  );
}
